import { Component, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ArtistListingsUiService } from '../../services/artist-listings-ui.service';
import { SongChartsUiService } from '../../services/song-charts-ui.service';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.html',
})
export class SidebarComponent {
  public authService = inject(AuthService);
  public layoutService = inject(LayoutService);
  public router = inject(Router);
  public isStreamingOpen = signal<boolean>(false);
  private artistListingsUi = inject(ArtistListingsUiService);
  private songChartsUi = inject(SongChartsUiService);

  constructor() {
    effect(() => {
      if (this.layoutService.isSidebarCollapsed()) {
        this.isStreamingOpen.set(false);
      }
    });
  }

  isStreamingRouteActive(): boolean {
    const url = this.router.url;
    return (
      url.startsWith('/charts/billboard') ||
      url.startsWith('/charts/spotify') ||
      url.startsWith('/charts/shazam') ||
      url.startsWith('/charts/apple-music')
    );
  }

  isShazamRouteActive(): boolean {
    return this.router.url.startsWith('/charts/shazam');
  }

  // Toggle dropdown state
  toggleStreamingMenu(): void {
    this.isStreamingOpen.update((open) => !open);
  }

  onStreamingClick(): void {
    if (this.layoutService.isSidebarCollapsed()) {
      this.layoutService.setSidebarCollapsed(false);
      this.isStreamingOpen.set(true);
    } else {
      this.toggleStreamingMenu();
    }
  }

  /** Same-route Overview clicks do not re-run routing; notify rankings to clear filters/sort. */
  onOverviewClick(): void {
    this.artistListingsUi.requestOverviewReset();
  }

  onChartsClick(): void {
    this.songChartsUi.requestChartsReset();
  }
}
